export var sizes = ['xs', 's', 'm', 'l', 'xl'];
export var views = {
  b2c: 'b2c',
  'b2c-primary': 'b2c_primary',
  b2b: 'b2b',
  'b2b-primary': 'b2b_primary',
  secondary: 'secondary',
  'secondary-white': 'secondary_white',
  destructive: 'destructive'
};
export var directions = ['left', 'right'];